import { images_path } from "../../constants";
import DownloadButton from "../../utils/components/DownloadButton";
import { getFileName } from "../../utils/genericUtils";
import styles from "./FilesComponent.module.scss";

const FilesComponent = ({
  fileObjects,
  onOpen = () => {},
  onDownload = () => {},
  onDelete,
}) => {
  return (
    <div className={styles.attachments}>
      {fileObjects
        ? fileObjects.map((fileObject, idx) => {
            return (
              <div key={idx} className={styles.file_attachment}>
                <a
                  target="_blank"
                  className={styles.file_name}
                  href={fileObject.file}
                  onClick={() => onOpen(fileObject)}
                >
                  {getFileName(fileObject.file)}
                </a>
                <DownloadButton className={styles.btn} fileObject={fileObject}>
                  <img
                    className={styles.download_icon}
                    src={images_path + "download.svg"}
                  ></img>
                </DownloadButton>
                <button title="Elimina" className={styles.btn}>
                  <img
                    className={styles.btn_icon}
                    src={images_path + "x_thin.svg"}
                    onClick={() => {
                      onDelete(fileObject);
                    }}
                  ></img>
                </button>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default FilesComponent;
